module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '6gf2gd8i',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
